import Divider from '@deliveryhero/pd-cookbook/components/Divider';
import Typography from '@deliveryhero/pd-cookbook/components/Typography';
import { Grid } from '@mui/material';

import { TestId } from 'components/GiftCard/constants';

import { LabelText } from './constants';
import { OrderSummaryProps } from './types';

import './styles.scss';

export const OrderSummary = (props: OrderSummaryProps) => {
  const { orderSummaryDetails, config } = props;

  const { subtotal, total, discountPercentage, discountAmount } =
    orderSummaryDetails;

  return (
    <Grid container spacing={2} className="order-summary-container">
      <Grid item xs={12}>
        <Grid item>
          <Typography type="title-md" color="neutral-primary" marginBottom="sm">
            {LabelText.TITLE}
          </Typography>
        </Grid>
        <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography type="label-lg" color="neutral-primary">
            {orderSummaryDetails.quantity} x {config.currencyCode}{' '}
            {orderSummaryDetails.giftCardValue} gift card
          </Typography>
          <Typography type="label-lg" color="neutral-primary">
            {config.currencyCode} {subtotal}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid
          item
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '8px'
          }}
        >
          <Typography type="label-lg" color="neutral-secondary">
            {LabelText.SUBTOTAL}
          </Typography>
          <Typography type="label-lg" color="neutral-secondary">
            {config.currencyCode} {subtotal}
          </Typography>
        </Grid>
        {Boolean(discountAmount) && (
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px'
            }}
          >
            <Typography
              type="label-lg"
              color="interaction-primary"
              data-testid={TestId.DiscountAmount}
            >
              {discountPercentage}% {LabelText.DISCOUNT}
            </Typography>
            <Typography type="label-lg" color="interaction-primary">
              {config.currencyCode} {discountAmount}
            </Typography>
          </Grid>
        )}
        <Grid item sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography type="title-md" color="neutral-primary">
            {LabelText.TOTAL}
          </Typography>
          <Typography type="title-md" color="neutral-primary">
            {config.currencyCode} {total}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};
